// Rank ladder: floor of the average of the net-worth tier and the followers tier.

import { TUNABLES } from "@degen/shared/config/tunables";

const R = TUNABLES.rank;

export type RankName = (typeof R.names)[number];

/** Highest index i where value >= thresholds[i]. */
export function tierIndex(value: number, thresholds: readonly number[]): number {
  let idx = 0;
  for (let i = 0; i < thresholds.length; i++) if (value >= thresholds[i]) idx = i;
  return idx;
}

export function rankIndex(netWorth: number, followers: number): number {
  return Math.floor((tierIndex(netWorth, R.netWorth) + tierIndex(followers, R.followers)) / 2);
}

export function rankName(index: number): RankName {
  return R.names[Math.max(0, Math.min(R.names.length - 1, index))];
}

export function hasKolBadge(followers: number, trust: number): boolean {
  return followers >= R.kolBadge.followers && trust >= R.kolBadge.trust;
}

/** Progress (0-1) toward the next tier on each axis, for Profile progress bars. */
export function rankProgress(netWorth: number, followers: number) {
  const prog = (v: number, th: readonly number[]) => {
    const i = tierIndex(v, th);
    if (i >= th.length - 1) return { tier: i, next: null as number | null, pct: 1 };
    return { tier: i, next: th[i + 1], pct: (v - th[i]) / (th[i + 1] - th[i]) };
  };
  return { netWorth: prog(netWorth, R.netWorth), followers: prog(followers, R.followers) };
}
